export class ImageReuqest{
    name:string
    elementType:number
    default:boolean
    main:boolean
    group:string
    constructor(){
        this.name=""
        this.elementType=1
        this.default = false
        this.main = false
        this.group = ""
    }
}